// libs
import React from 'react';

// components
import PlainWidget from './components/PlainWidget';
import AttributeWidget from './components/AttributeWidget';
import ParentWidget from './components/ParentWidget';

// constants
import { WIDGET_TYPES } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/constants';

// types
import { IWidget } from 'shared/layouts/DetailsPage/components/ProductInfo/components/ProductDescription/types';

interface ICollapsibleContent {
  widget: IWidget;
}

function CollapsibleContent({ widget }: ICollapsibleContent) {
  const getWidgetComponent = (widget_data: IWidget) => {
    const type = widget_data.widget_type;

    switch (type) {
      case WIDGET_TYPES.parentWidget:
        return <ParentWidget widget={widget} />;

      case WIDGET_TYPES.plainCollapsableWidget:
        return <PlainWidget widget={widget} showTitle={false}></PlainWidget>;

      case WIDGET_TYPES.attributeWidget:
        return <AttributeWidget widget={widget} />;
    }
  };
  return <>{getWidgetComponent(widget)}</>;
}

export default CollapsibleContent;
